import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Inventory() {
  const [data, setData] = useState({ batches: [], by_part: [] });
  const [view, setView] = useState("rollup"); // rollup | batches

  useEffect(() => { (async () => setData((await api.get("/inventory")).data))(); }, []);

  return (
    <div className="space-y-6" data-testid="inventory-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-4xl uppercase tracking-tighter">Inventory</h1>
          <p className="text-xs text-zinc-600 mt-1">Live stock derived from GRN batches</p>
        </div>
        <div className="flex gap-2">
          <button onClick={() => setView("rollup")} data-testid="view-rollup" className={`brut-tag ${view === "rollup" ? "brut-tag-dark" : "brut-tag-white"}`}>Roll-up by Part</button>
          <button onClick={() => setView("batches")} data-testid="view-batches" className={`brut-tag ${view === "batches" ? "brut-tag-dark" : "brut-tag-white"}`}>Batch Detail</button>
        </div>
      </div>

      {view === "rollup" ? (
        <div className="brut-card overflow-x-auto">
          <table className="brut-table" data-testid="inventory-rollup-table">
            <thead><tr><th>Part #</th><th>Name</th><th>Category</th><th>Unit</th><th>Batches</th><th>On Hand</th></tr></thead>
            <tbody>
              {data.by_part.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-zinc-500">No stock yet.</td></tr>}
              {data.by_part.map((p) => (
                <tr key={p.part_id} data-testid={`inv-part-${p.part_number}`}>
                  <td className="font-bold">{p.part_number}</td>
                  <td>{p.part_name}</td>
                  <td><span className="brut-tag brut-tag-yellow">{p.part_category}</span></td>
                  <td>{p.unit}</td>
                  <td className="font-mono-ui">{p.batch_count}</td>
                  <td className="font-mono-ui font-bold">{p.total_remaining}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="brut-card overflow-x-auto">
          <table className="brut-table" data-testid="inventory-batches-table">
            <thead><tr><th>GRN #</th><th>Supplier</th><th>Received</th><th>Part #</th><th>Name</th><th>Category</th><th>Received Qty</th><th>Remaining</th></tr></thead>
            <tbody>
              {data.batches.length === 0 && <tr><td colSpan={8} className="text-center py-8 text-zinc-500">No stock yet.</td></tr>}
              {data.batches.map((b) => (
                <tr key={b.line_id} data-testid={`inv-batch-${b.line_id}`}>
                  <td className="font-bold">{b.grn_number}</td>
                  <td>{b.supplier_name}</td>
                  <td>{b.received_date}</td>
                  <td className="font-bold">{b.part_number}</td>
                  <td>{b.part_name}</td>
                  <td><span className="brut-tag brut-tag-yellow">{b.part_category}</span></td>
                  <td className="font-mono-ui">{b.qty_received}</td>
                  <td className="font-mono-ui font-bold">{b.qty_remaining}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
